import assign from 'lodash/assign';
import { LaunchUpdatePaymentModalService } from '../updatePaymentModal/launchUpdatePaymentModal.service';

export const UpdatePaymentButtonComponent = angular
    .module('app.components.updatePayment.updatePaymentButton', [
        LaunchUpdatePaymentModalService
    ]).component('updatePaymentButton', {
        template: `
            <md-button
                ng-click="$ctrl.launchModal($event)"
                class="{{$ctrl.buttonClass}}"
                aria-label="{{'UPDATEPAYMENT.LAUNCH_MODAL_BUTTON' | translate}}">
                <span ng-if="$ctrl.editMode === 'update'">
                    {{'UPDATEPAYMENT.LAUNCH_MODAL_BUTTON' | translate}}
                </span>
                <span ng-if="$ctrl.editMode === 'new'">
                    <md-icon>add</md-icon> {{'UPDATEPAYMENT.LAUNCH_MODAL_BUTTON_ADD' | translate}}
                </span>
            </md-button>
        `,
        bindings: {
            buttonClass: '@',
            editMode: '@',
            prefillData: '<',
            onPaymentMethodChanged: '&'
        },
        controller: class UpdatePaymentButtonController {
            constructor(
                $scope,
                launchUpdatePaymentService
            ) {
                'ngInject';

                assign(this, {
                    $scope,
                    launchUpdatePaymentService
                });
            }

            $onInit() {}

            launchModal(ev) {
                this.launchUpdatePaymentService.launchModal(this.editMode, this.prefillData, ev).then((cardInfo) => {
                    this.onPaymentMethodChanged({ cardInfo });
                });
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/updatePayment/updatePaymentButton/updatePaymentButton.component.js